import { APP_PERMISSIONS } from '@exam-center/permission';
import { Navigate, useParams } from '@exam-center/router';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

export default function ProctorsPage() {
  const { examCenterCode } = useParams('/:examCenterCode/exam-proctors/proctors');

  const { permissions } = usePermission();

  const initialPath = useMemo(() => {
    if (permissions.includes(APP_PERMISSIONS.PROCTOR_MANAGEMENT.PROCTOR.VIEW)) {
      return `/:examCenterCode/exam-proctors/proctors`;
    }
    if (permissions.includes(APP_PERMISSIONS.PROCTOR_MANAGEMENT.PROCTOR_REQUEST.VIEW)) {
      return `/:examCenterCode/exam-proctors/requests`;
    }
  }, [permissions]);

  if (!initialPath) {
    return <Navigate to='/access-denied' replace />;
  }

  return <Navigate to={initialPath} replace params={{ examCenterCode }} />;
}
